import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { EmployeeContractManagerLinkSerializer } from './employee-contract-manager-link.serializer'
import { Observable } from 'rxjs'
import {
  EmployeeBooking,
  EmployeeBookingTypes
} from '../employee-booking/employee-booking'
import moment from 'moment-mini'

import { Product } from '../../product/product'
import { Dictionary } from '@ngrx/entity'
import { groupBy } from 'src/app/shared/utils'
import { EmployeeContractManagerLink } from './employee-contract-manager-link'

@Injectable()
export class EmployeeContractManagerLinkService extends ResourceService<EmployeeContractManagerLink> {
  public employeeBookingTypes = EmployeeBookingTypes

  constructor(
    private http: HttpClient,
    private employeeContractManagerLinkSerializer: EmployeeContractManagerLinkSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/employee-contracts`,
      employeeContractManagerLinkSerializer
    )
  }
}
